module.exports = __webpack_public_path__ + "static/media/shelby.0fc8bc71.jpg";